import logo from './logo.svg';
import './App.css';
import Home from './pages/home';
import { Route, Routes } from 'react-router-dom';
import Header from './components/header';
import Destination from './pages/destination';
import About from './pages/about';
import Contact from './pages/contact';
import Footer from './components/footer';

function App() {
  return (
    <>
      <Header/>
      <Routes>
        <Route path="/" element={<Home/>}/>
        <Route path="/destination" element={<Destination/>}/>
        <Route path="/about" element={<About/>}/>
        <Route path="/contact" element={<Contact/>}/>
      </Routes>
      <Footer/>
    </>
  );
}

export default App;
